import { Pipe, PipeTransform, inject } from '@angular/core';
import { Guid, isNil, Nillable } from '@web/utils';
import { Observable, of } from 'rxjs';
import { AdminMultimediaDataSourceService } from '../services/admin-multimedia-data-source.service';
import { AdminMultimediaDetails } from '../models/admin-multimedia-details';

@Pipe({
  name: 'adminFetchMultimediaById',
  standalone: true,
})
export class AdminFetchMultimediaByIdPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly multimediaDataSource = inject(AdminMultimediaDataSourceService);

  public transform(
    id: Nillable<Guid>,
    cacheable = true,
  ): Observable<Nillable<AdminMultimediaDetails>> {
    if (isNil(id)) {
      return of(null);
    }

    return this.multimediaDataSource.fetchDetailsById(id, cacheable);
  }
}
